export enum ButtonSeverity {
  success = 'success',
  primary = 'primary',
  secondary = 'secondary',
  tertiary = 'tertiary',
  ghost = 'ghost',
  download = 'download',
  danger = 'danger',
  info = 'info',
  help = 'help',
  error = 'error',
  warning = 'warning',
}
